import {
	TRIGGER_INIT_SEND_MONEY_BANK_DETAILS_API,
	TRIGGER_INIT_SEND_MONEY_BANK_DETAILS_API_SUCCESS,
} from 'redux/actionTypes';

export function triggerInitSendMoneyBankDetailsApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_INIT_SEND_MONEY_BANK_DETAILS_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerInitSendMoneyBankDetailsApiCallSuccess(data) {
	return {
		type: TRIGGER_INIT_SEND_MONEY_BANK_DETAILS_API_SUCCESS,
		data,
	};
}
